var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingRevenueData),expression:"loadingRevenueData"}],attrs:{"element-loading-spinner":"qc-spinner","loading":_vm.loadingRevenueData,"id":"canvasContainer"}},[_c('canvas',{attrs:{"id":"revenueGraph"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }